import React from "react";
import "../styles/staffportal.css";
import rambLogo from "../assets/logo.png";

const portals = [
    {
        name: "Pawning Portal",
        description: "Access the RAMB Pawning management system",
        url: "https://goldplus.rambgroup.com/login-landing",
        icon: "💎",
        color: "#c084fc",
        glow: "rgba(192, 132, 252, 0.3)",
    },
    {
        name: "Gold Plus Portal",
        description: "Access the Gold Plus system",
        url: "https://goldplus.rambgroup.com/gold/login",
        icon: "🏅",
        color: "#fbbf24",
        glow: "rgba(251, 191, 36, 0.3)",
    },
    {
        name: "Visa Portal",
        description: "Access the RAMB Visa processing system",
        url: "https://visa.rambgroup.com/login",
        icon: "✈️",
        color: "#38bdf8",
        glow: "rgba(56, 189, 248, 0.3)",
    },
];

const StaffPortal = () => {
    return (
        <div className="sp-page">
            {/* Background blobs */}
            <div className="sp-blob sp-blob-1" />
            <div className="sp-blob sp-blob-2" />

            <div className="sp-container">
                {/* Header */}
                <div className="sp-header">
                    <img src={rambLogo} alt="RAMB" className="sp-logo" />
                    <h1 className="sp-title">Staff Portal</h1>
                    <p className="sp-subtitle">
                        Select your portal to sign in. These links are for authorised RAMB staff only.
                    </p>
                    <div className="sp-badge">🔒 Restricted Access — Staff Only</div>
                </div>

                {/* Cards */}
                <div className="sp-cards">
                    {portals.map((p) => (
                        <a
                            key={p.name}
                            href={p.url}
                            target="_blank"
                            rel="noreferrer"
                            className="sp-card"
                            style={{ "--accent": p.color, "--glow": p.glow }}
                        >
                            <div className="sp-card-icon">{p.icon}</div>
                            <div className="sp-card-body">
                                <h2 className="sp-card-name">{p.name}</h2>
                                <p className="sp-card-desc">{p.description}</p>
                            </div>
                            <div className="sp-card-arrow">→</div>
                        </a>
                    ))}
                </div>

                <p className="sp-note">
                    Having trouble accessing a portal? Contact your system administrator.
                </p>
            </div>
        </div>
    );
};

export default StaffPortal;
